// src/components/FolderTree/FolderTreeErrorBoundary.jsx
import React from 'react';
import { Text } from '@zenqms/zui';

export class FolderTreeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[FolderTreeErrorBoundary]', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="folder-tree-error" role="alert">
          <Text size="md">{this.props.fallbackMessage}</Text>
        </div>
      );
    }
    return this.props.children;
  }
}
